import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const ShiftTypeService = {
    getShiftType() {
        return httpClient.post(endPoints.getShiftType);
    },
    deleteShiftType(obj) {
        return httpClient.post(endPoints.deleteShiftType, obj);
    },
    updateShiftType(obj) {
        return httpClient.post(endPoints.updateShiftType, obj);
    },
    addShiftType(obj) {
        return httpClient.post(endPoints.addShiftType, obj);
    }
};

export default ShiftTypeService;



// WEBPACK FOOTER //
// ./src/service/ShiftTypeService.js